import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "katex/dist/katex.css";
// 自定义指令,有头像就显示,没有头像就显示默认的
import * as directives from "@/directives/index";
import latex from "./util/latex";
import x2js from "x2js"; //xml数据处理插件

window.x2js = new x2js();
Vue.prototype.commonsVariable = latex;
//注册为指令,渲染公式
import Katex from "vue-katex-auto-render";
Vue.directive("katex", Katex);
Vue.config.productionTip = false;
Vue.use(ElementUI);

Object.keys(directives).forEach(key => {
  // keys() 把导出的所有对象转换成数组,遍历里面的每一项
  Vue.directive(key, directives[key]); // 键-值 形式,添加 directive()为vue的指令
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
